import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import AppShell from "@/components/AppShell";
import Landing from "@/pages/Landing";
import LoansHub from "@/pages/LoansHub";
import LoanDetail from "@/pages/LoanDetail";
import ProposalForm from "@/pages/ProposalForm";
import ProposalPreview from "@/pages/ProposalPreview";
import ProposalsList from "@/pages/ProposalsList";
import CompareBankingSystems from "@/pages/CompareBankingSystems";
import SharedComparison from "@/pages/SharedComparison";
import FollowUps from "@/pages/FollowUps";
import EmailEventsDashboard from "@/pages/EmailEventsDashboard";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppShell>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/loans" element={<LoansHub />} />
            <Route path="/loans/:industryId" element={<LoanDetail />} />
            <Route path="/compare" element={<CompareBankingSystems />} />
            <Route path="/c/:comparisonId" element={<SharedComparison />} />
            <Route path="/followups" element={<FollowUps />} />
            <Route path="/email-events" element={<EmailEventsDashboard />} />
            <Route path="/proposals" element={<ProposalsList />} />
            <Route path="/proposals/new" element={<ProposalForm />} />
            <Route path="/proposals/draft/preview" element={<ProposalPreview />} />
            <Route path="/proposals/:id" element={<ProposalPreview />} />
          </Routes>
        </AppShell>
        <Toaster position="top-right" richColors closeButton />
      </BrowserRouter>
    </div>
  );
}

export default App;
